import { useWindowSize } from "@uidotdev/usehooks";

export default function useIsMobile(){
  const { width: windowWidth } = useWindowSize();
  const isMobile = windowWidth != null && windowWidth < 640;
  return [isMobile];
}